<p-progressSpinner class="resy_spinner spinner_in_front" *ngIf="spinner"></p-progressSpinner>
<div *ngIf="spinner && capacityTemplates.length === 0" class="hosts-spinner-helper"></div>
<div class="hosts-table-container" *ngIf="capacityTemplates.length > 0">
  <p-table [value]="capacityTemplates" dataKey="id" styleClass="p-datatable-sm" responsiveLayout="stack"
           [breakpoint]="'550px'" [tableStyle]="{'width':'100%', 'cursor': 'pointer'}">
    <ng-template pTemplate="body" let-capacity let-ri="rowIndex">
      <tr (click)="editCapacity(capacity)" [class.lighter]="capacity.isDefault">
        <td class="hosts-table-first-column" title="{{capacity.name}}">
          <b class="p-column-title">{{'VENUE.NAME' | translate}}</b>
          <b>{{capacity.name}}</b>
        </td>
        <td>
          <b class="p-column-title">{{'VENUE.DATE' | translate}}</b>
          <ng-container *ngIf="capacity.startDate && capacity.endDate">
            {{capacity.startDate | date: 'dd.MM.yyyy'}}-{{capacity.endDate | date: 'dd.MM.yyyy'}}
          </ng-container>
        </td>
        <td>
          <b class="p-column-title">{{'VENUE.TIME' | translate}}</b>
          <ng-container *ngIf="capacity.startTime && capacity.endTime">
            {{parseTime(capacity.startTime) | date: 'hh:mm a'}}-{{parseTime(capacity.endTime) | date: 'hh:mm a'}}
          </ng-container>
        </td>
        <td class="hosts-table-last-column">
          <b class="p-column-title"></b>
          <div class="d-flex align-items-center justify-content-center gap-2" *ngIf="!capacity.isDefault">
            <button pButton pRipple type="button" icon="pi pi-pencil"
                    (click)="$event.stopPropagation();updateCapacityDetails(capacity)" class="p-button-rounded table-btn"></button>
            <button pButton pRipple type="button" icon="pi pi-trash"
                    (click)="$event.stopPropagation();deleteCapacityTemplate(capacity.id)" class="p-button-rounded table-btn"></button>
          </div>
          <div class="d-flex align-items-end justify-content-end">
            <button pButton pRipple type="button" icon="pi pi-pencil" *ngIf="capacity.isDefault"
                    class="p-button-rounded table-btn justify-content-end me-1"></button>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
<div class="d-flex w-100 flex-column justify-content-center no-reservations-container" *ngIf="capacityTemplates.length === 0 && !spinner">
  <i class="pi pi-search-minus no-reservations-icon"></i>
  <span class="no-reservations-text">{{'VENUE.NO_TABLE_CAPACITY_TEMPLATES' | translate}}</span>
</div>
<div class="d-flex flex-row justify-content-between pt-3" style="padding: 0 20px 0 20px;">
  <button class="create_btn w-50" (click)="chooseAndOpenAddCapacityDialog()">{{ 'VENUE.ADD_NEW' |translate}}</button>
  <div class="w-50 ms-2 d-flex justify-content-center">
    <button class="btn_cancel_no_border m-0" (click)="cancel()">{{ 'CLOSE' | translate}}</button>
  </div>
</div>
<p-toast position="bottom-center" [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'" [styleClass]="'popup-toast'"></p-toast>
